/**
 * Opens Swym's wishlist drawer from the theme's own header heart.
 *
 * The heart (#header-wishlist-icon in snippets/header-actions.liquid) stays a
 * real link to /pages/your-wishlist, so it still works with JavaScript off or
 * if the Swym app embed fails to load. When Swym's storefront layout is
 * available we intercept the click and slide the drawer open instead.
 *
 * Swym drives the drawer off a URL hash — _swat.ui.open() does nothing but set
 * window.location.hash — and clears the hash again when the drawer closes, so
 * assigning the same hash repeatedly reopens it reliably.
 *
 * Tracking whether it's open is less direct. Swym fires a
 * SwymStorefrontLayoutOpened event but has no matching "closed" event, and it
 * clears the hash without firing hashchange. The drawer's own
 * swym-storefront-layout-hide-view class is the one signal that reflects both
 * directions, so aria-expanded is driven off a MutationObserver watching it.
 *
 * The click handler is delegated off document so it survives the header being
 * re-rendered by Shopify section rendering.
 */
(function () {
  var TRIGGER_ID = 'header-wishlist-icon';
  var DRAWER_SELECTOR = '.swym-storefront-layout-drawer';
  var HIDDEN_CLASS = 'swym-storefront-layout-hide-view';

  var observing = false;

  function trigger() {
    return document.getElementById(TRIGGER_ID);
  }

  /**
   * The hash that opens the wishlist drawer, or null when Swym's drawer isn't
   * available — in which case the link is left alone to navigate normally.
   * @returns {string|null}
   */
  function drawerHash() {
    var context = window.SwymStorefrontLayoutContext;
    if (!context || !context.Settings || !context.Settings.EnableStorefrontLayout) return null;
    return (context.StorefrontLayoutUrls && context.StorefrontLayoutUrls.List) || null;
  }

  /** Mirror the drawer's real open state onto the header link. */
  function syncExpanded() {
    var link = trigger();
    if (!link || !drawerHash()) return;
    var drawer = document.querySelector(DRAWER_SELECTOR);
    var isOpen = !!drawer && !drawer.classList.contains(HIDDEN_CLASS);
    link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  /** Watch the drawer's class, which is the only signal that tracks closing. */
  function observeDrawer() {
    if (observing) return;
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    observing = true;
    new MutationObserver(syncExpanded).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    syncExpanded();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('#' + TRIGGER_ID) : null;
    if (!link) return;

    var hash = drawerHash();
    // No drawer — fall through to /pages/your-wishlist.
    if (!hash) return;

    // Let modified clicks (new tab, etc.) behave like a normal link.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0)
      return;

    event.preventDefault();
    window.location.hash = hash;
    observeDrawer();
    syncExpanded();
  });

  // Swym injects the drawer late, so pick it up whenever it first opens.
  document.addEventListener('SwymStorefrontLayoutOpened', function () {
    observeDrawer();
    syncExpanded();
  });

  /**
   * Announce the link as a dialog trigger only once Swym confirms the drawer
   * exists, so the markup doesn't promise a popup that can never open.
   */
  function markAsDialogTrigger() {
    var link = trigger();
    if (!link || !drawerHash()) return;
    link.setAttribute('aria-haspopup', 'dialog');
    observeDrawer();
    syncExpanded();
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(markAsDialogTrigger);
  markAsDialogTrigger();
})();
